import {
  Card,
  FormHelperText,
  Grid,
  InputLabel,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import InputField from "../../../../common/InputField";
import "./CareDirective.scss";
import {
  LinkButton,
  PrimaryButton,
  SecondaryButton,
} from "../../../../common/Buttons";
import {
  setCareDirectiveData,
  getCareDirectiveData,
} from "../../../../services/documentServices";
import { toast } from "react-hot-toast";
import { setStepStatus } from "../../../../utils/Utilities";
import { useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const BodyCare = ({ next, setButtonDisabled }) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [initialValues, setInitialValues] = useState({
    bodyCareLike: "",
    bodyCareWish: "",
    bodyCareDislike: "",
  });

  const validate = Yup.object({
    bodyCareLike: Yup.string().nullable(),
    bodyCareWish: Yup.string().nullable(),
    bodyCareDislike: Yup.string().nullable(),
  });

  const handleSubmit = async (values) => {
    setButtonDisabled(true);
    const { stepStatus, bodyCareId, careDirectiveId, ...rest } = values;
    const payload = {
      ...data,
      bodyCare: {
        ...rest,
        bodyCareId,
        careDirectiveId,
        stepStatus: setStepStatus("00-00-0000", { ...rest }),
      },
    };
    const result = await setCareDirectiveData(payload, id);
    if (result?.success) {
      next();
    }
    setButtonDisabled(false);
  };

  const getCareDirectiveDataFun = async () => {
    setButtonDisabled(true);
    const result = await getCareDirectiveData(id);
    if (result?.success && result?.payLoad) {
      setData(result.payLoad);
      if (result.payLoad.bodyCare !== null) {
        setInitialValues(result.payLoad.bodyCare);
      }
    }
    setButtonDisabled(false);
  };

  useEffect(() => {
    getCareDirectiveDataFun();
  }, []);

  return (
    <Card className="care-directive documents-card-height summary-table">
      <Grid container>
        <Grid item lg={7} md={6} sm={12} xs={12} className="outer outer-pt-10">
          <Formik
            initialValues={initialValues}
            enableReinitialize
            validationSchema={validate}
            onSubmit={(values) => handleSubmit(values)}
          >
            {(formik) => (
              <Form id="form_submit" onSubmit={formik.handleSubmit}>
                <InputLabel sx={{ mt: 2, color: "color.magentaDark2" }}>
                  {t("cd-bd-text-1")}
                </InputLabel>
                <FormHelperText sx={{ color: "color.magentaDark2" }}>
                  {t("cd-bd-text-2")}
                </FormHelperText>
                <InputField
                  fullWidth
                  multiline
                  rows={3}
                  variant="outlined"
                  name="bodyCareLike"
                  type="text"
                />
                <FormHelperText sx={{ mt: 2, color: "color.magentaDark2" }}>
                  {t("cd-bd-text-3")}
                </FormHelperText>
                <InputField
                  fullWidth
                  multiline
                  rows={3}
                  variant="outlined"
                  name="bodyCareWish"
                  type="text"
                />
                <FormHelperText sx={{ mt: 2, color: "color.magentaDark2" }}>
                  {t("cd-bd-text-4")}
                </FormHelperText>
                <InputField
                  fullWidth
                  multiline
                  rows={3}
                  variant="outlined"
                  name="bodyCareDislike"
                  type="text"
                />
              </Form>
            )}
          </Formik>
        </Grid>
      </Grid>
    </Card>
  );
};

export default BodyCare;
